module.exports = __webpack_public_path__ + "static/default-og-image-ea6b3685995102dc76b4660d2547b82d.jpg";